import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { aplicarMarca, MARCA_ENTERATEK } from './lib/tema.js';
import { Cascaron } from './piezas/Cascaron.jsx';
import { Cargando } from './piezas/Estados.jsx';
import { ProveedorSesion, useSesion } from './piezas/Sesion.jsx';
import { ProveedorFiltros } from './lib/filtros.jsx';
import { Acceso } from './pantallas/Acceso.jsx';
import { Analitica } from './pantallas/Analitica.jsx';
import { Ajustes } from './pantallas/Ajustes.jsx';
import { Auditoria } from './pantallas/Auditoria.jsx';
import { Biblioteca } from './pantallas/Biblioteca.jsx';
import { Catalogos } from './pantallas/Catalogos.jsx';
import { Consulta } from './pantallas/Consulta.jsx';
import { Torre } from './pantallas/Torre.jsx';
import { Clientes, Contratos, Proyectos } from './pantallas/Comercial.jsx';
import { Embarque } from './pantallas/Embarque.jsx';
import { Existencias, Resguardos } from './pantallas/Existencias.jsx';
import { Guia, Guias } from './pantallas/Guias.jsx';
import { Movimientos } from './pantallas/Movimientos.jsx';
import { Idcs, Sitios } from './pantallas/Operacion.jsx';
import { Rastreo } from './pantallas/Rastreo.jsx';
import { Remesa, Remesas } from './pantallas/Remesas.jsx';
import { Padron, Recepciones, TableroStaging } from './pantallas/Staging.jsx';
import { Tablero } from './pantallas/Tablero.jsx';
import { Ticket, Tickets } from './pantallas/Tickets.jsx';

/* La marca se inyecta al arrancar, no se escribe en el CSS: asi la plataforma
   se viste con la marca del cliente sin tocar una hoja de estilos. */
aplicarMarca(MARCA_ENTERATEK.brand, MARCA_ENTERATEK.brand2);

function Rutas(): JSX.Element {
  const { usuario, cargando } = useSesion();

  if (cargando) {
    return (
      <div className="acceso">
        <Cargando que="la sesion" />
      </div>
    );
  }

  /* Sin sesion, todo lleva al acceso. La autorizacion de verdad la impone el
     servidor: esto solo evita pantallas que van a devolver 401. */
  if (!usuario) return <Acceso />;

  return (
    <ProveedorFiltros>
      <Cascaron>
        <Routes>
          <Route path="/" element={<Tablero />} />
          <Route path="/consulta" element={<Consulta />} />
          <Route path="/torre" element={<Torre />} />
          <Route path="/biblioteca" element={<Biblioteca />} />
          <Route path="/staging" element={<TableroStaging />} />
          <Route path="/recepciones" element={<Recepciones />} />
          <Route path="/equipos" element={<Padron />} />
          <Route path="/remesas" element={<Remesas />} />
          <Route path="/remesas/:folio" element={<Remesa />} />
          <Route path="/embarque" element={<Embarque />} />
          <Route path="/analitica" element={<Analitica />} />
          <Route path="/tickets" element={<Tickets />} />
          <Route path="/tickets/:folio" element={<Ticket />} />
          <Route path="/existencias" element={<Existencias />} />
          <Route path="/resguardos" element={<Resguardos />} />
          <Route path="/rastreo" element={<Rastreo />} />
          <Route path="/sitios" element={<Sitios />} />
          <Route path="/clientes" element={<Clientes />} />
          <Route path="/contratos" element={<Contratos />} />
          <Route path="/proyectos" element={<Proyectos />} />
          <Route path="/idc" element={<Idcs />} />
          <Route path="/guias" element={<Guias />} />
          <Route path="/guias/:folio" element={<Guia />} />
          <Route path="/movimientos" element={<Movimientos />} />
          <Route path="/catalogos" element={<Catalogos />} />
          <Route path="/ajustes" element={<Ajustes />} />
          <Route path="/auditoria" element={<Auditoria />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Cascaron>
    </ProveedorFiltros>
  );
}

export function App(): JSX.Element {
  return (
    <ProveedorSesion>
      <BrowserRouter>
        <Rutas />
      </BrowserRouter>
    </ProveedorSesion>
  );
}
